module.exports = __webpack_public_path__ + "img/product-7.9548018d.jpg";